import Vue from 'vue'
import VueRouter from 'vue-router'

import routeConfig from './route'

import { queryConfig } from '@/share/services/share.services'
import { initSdk } from '@/public/sdkInit'

Vue.use(VueRouter)

const router = new VueRouter(routeConfig)

initSdk(router, queryConfig)

export default router
